export const GET_REWARD_PENDING = 'GET_REWARD_PENDING';
export const GET_REWARD_FULFILLED = 'GET_REWARD_FULFILLED';
export const GET_REWARD_REJECTED = 'GET_REWARD_REJECTED';
export const SAVE_TRANSFER_POINTS_PENDING = 'SAVE_TRANSFER_POINTS_PENDING';
export const SAVE_TRANSFER_POINTS_FULFILLED = 'SAVE_TRANSFER_POINTS_FULFILLED';
export const SAVE_TRANSFER_POINTS_REJECTED = 'SAVE_TRANSFER_POINTS_REJECTED';
export const GET_TRANSFER_VALUE_PENDING = 'GET_TRANSFER_VALUE_PENDING';
export const GET_TRANSFER_VALUE_FULFILLED = 'GET_TRANSFER_VALUE_FULFILLED';
export const GET_TRANSFER_VALUE_REJECTED = 'GET_TRANSFER_VALUE_REJECTED';

export default function rewardsReducer(state = {
  fetching: false,
  fetched: false,
  euroValue: 0,
  individualRewards: {},
  errors: {},
  meta: []
}, action) {
  switch (action.type) {
    case GET_REWARD_PENDING:
    case GET_TRANSFER_VALUE_PENDING:
    case SAVE_TRANSFER_POINTS_PENDING: {
      return {
        ...state,
        fetching: true,
        fetched: false
      };
    }
    case GET_REWARD_FULFILLED: {
      return {
        ...state,
        fetching: false,
        fetched: true,
        individualRewards: action.payload.data.attributes.individual_rewards,
        meta: action.payload.meta
      }
    }
    case GET_TRANSFER_VALUE_FULFILLED: {
      return {
        ...state,
        fetching: false,
        fetched: true,
        pointValue: action.payload.data.attributes.points
      }
    }
    case SAVE_TRANSFER_POINTS_FULFILLED: {
      return {
        ...state,
        fetching: false,
        fetched: true,
        individualRewards: {
          ...state.individualRewards,
          order: {
            ...state.individualRewards.order,
            next_order_amount: action.payload.data.attributes.individual_rewards.order.next_order_amount,
            individual_balance: action.payload.data.attributes.individual_rewards.order.individual_balance,
            transfer_amount: action.payload.data.attributes.individual_rewards.order.transfer_amount
          }
        }
      }
    }
    case GET_REWARD_REJECTED:
    case SAVE_TRANSFER_POINTS_REJECTED: {
      return {
        ...state,
        fetching: false,
        fetched: false,
        errors: action.payload.errors
      }
    }
  }

  return { ...state };
};



// WEBPACK FOOTER //
// ./src/reducers/rewardsReducer.js